import { Box, TableCell, Typography } from "@mui/material";
import { formatFindingsCount } from "~/components/FirewatchRow/Cells/firewatchTableCellUtils";

type TopActionsAssetsCountCellProps = {
  count: number;
  isSmallTable: boolean;
};

export const TopActionsAssetsCountCell = ({
  count,
  isSmallTable,
}: TopActionsAssetsCountCellProps) => {
  return (
    <TableCell sx={isSmallTable ? { pl: "5px !important" } : {}}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="caption">{formatFindingsCount(count)}</Typography>
      </Box>
    </TableCell>
  );
};
